export { default } from './CalaixBotons';
